import { useQuery } from "react-query";
import API from "../shared-utils/api";
export const getPubOffers = async (pub_id, categories = []) => {
    let url = `/api/v1/rbzo/discountoffers/pubs/${pub_id}`;
    if (categories.length > 0) {
        const categoryParam = categories.map(encodeURIComponent).join(",");
        url += `?offerCategory=${categoryParam}`;
    }
    const { data } = await API.get(url);
    return data;
};
export const useDiscountOffer = (pub_id, categories) => {
    return useQuery([`pub_offers`, pub_id, categories || []], () => getPubOffers(pub_id, categories || []), {
        staleTime: 10 * 60 * 1000,
        cacheTime: 15 * 60 * 1000,
    });
};
